import { useVenueDataContext } from '@/VenueDataLoader'

export function useClientTokenData() {
  const { clientInfo } = useVenueDataContext()
  return clientInfo
}
